export const appExcel = "EuKDwc";
export default {appExcel};